export const PRODUCT_IMAGE = 1;
export const FORMULA_NOTE_IMAGE = 2;
export const GENERIC_IMAGE = 3;
export const INSTRUCTIONS = 4;
export const SAFETY_SHEET = 5;
export const TECHNICAL_SHEET = 6;
export const BANNER_IMAGE = 7;
export const COLORANT_IMAGE = 8;
export const ICON = 9;
export const IMAGE = 10;
export const STATIC_SQL = 11;
